import { useState } from "react";

import { Card } from "../../../common/Atoms/Card";
import { Button } from "../../../common/Atoms/Button";
import { useInvoice } from "../../hooks/useInvoice";
import { useCreateNoteMutation } from "../../services/api/invoiceApi/invoice";
import { Notes } from "../Molecules/Notes";
import { LogActivityModal } from "../CRM/ContactPage/LogActivityModal";

/** `invoiceId` overrides the route param, e.g. when rendered in the notes drawer (renders without the card) */
export function InvoiceNotes({ invoiceId }: { invoiceId?: string } = {}) {
  const { data: invoice } = useInvoice(invoiceId);
  const [postNewNote, { isLoading: isPostingNote }] = useCreateNoteMutation();
  const [recordActivityOpen, setRecordActivityOpen] = useState(false);

  if (!invoice) return null;

  async function onNewNote(content: string, mentionedUsers: string[], attachments: File[], syncAttachments: boolean) {
    // Create the note
    await postNewNote({
      organisationId: invoice.invoice.organisation_id,
      invoiceId: invoice.invoice.id,
      content,
      mentionedUsers,
      attachments,
      syncAttachments,
    });
  }

  const content = (
    <>
      <div className={ `flex justify-end mb-3` }>
        <Button
          color={ `paidniceGreenOutline` }
          size={ `sm` }
          onClick={ () => setRecordActivityOpen(true) }
        >
          { `Record Activity` }
        </Button>
      </div>

      { /* Display existing notes */ }
      <Notes
        notes={ invoice.notes }
        loading={ isPostingNote }
        enableNewNote
        onSave={ onNewNote }
      />

      <LogActivityModal
        open={ recordActivityOpen }
        setOpen={ setRecordActivityOpen }
        organisationId={ invoice.invoice.organisation_id }
        contactId={ invoice.invoice.contact_id }
        invoiceId={ invoice.invoice.id }
      />
    </>
  );

  return invoiceId ? content : <Card>{ content }</Card>;
}
